jQuery(function ($) {
  let page = 2,
    loading = false,
    ajaxurl = $('#load-more-button')
      ? $('#load-more-button').attr('data-ajaxurl')
      : '';

  function onSuccessCall(page, maxPages, container, response, loadmore = true) {
    loading = false;
    if (page > maxPages || !loadmore) {
      $('#load-more-button').remove();
      $('.error-message').hide();
    } else {
      $('#load-more-button').text('Afficher plus');
    }

    $(container).append(response);
  }

  function hideCardsAfterCall() {
    let typeVal =
        $('#filter-type').length > 0
          ? $('#filter-type').find(':selected').val()
          : '',
      themeVal =
        $('#filter-theme').length > 0
          ? $('#filter-theme').find(':selected').val()
          : '',
      sectorVal =
        $('#filter-sector').length > 0
          ? $('#filter-sector').find(':selected').val()
          : '',
      dateVal =
        $('#filter-month').length > 0
          ? $('#filter-month').find(':selected').val()
          : '',
      catVal =
        $('#filter-cat').length > 0
          ? $('#filter-cat').find(':selected').val()
          : '';

    if (typeVal !== '') {
      $('.formation-card')
        .not('[data-type=' + typeVal + ']')
        .addClass('hide-type');
    }

    if (themeVal !== '') {
      $('.formation-card')
        .not('[data-theme=' + themeVal + ']')
        .addClass('hide-theme');
    }

    if (sectorVal !== '') {
      $('.formation-card')
        .not('[data-sector=' + sectorVal + ']')
        .addClass('hide-sector');
    }

    if (dateVal !== '') {
      $('.formation-card')
        .not('[data-month=' + dateVal + ']')
        .addClass('hide-month');
    }

    if (catVal !== '') {
      $('.formation-card')
        .not('[data-cat=' + catVal + ']')
        .addClass('hide-cat');
    }
  }

  if ($('.ccecqa-blog-articles')) {
    let maxPages = $('.ccecqa-blog-articles').attr('data-max');

    $('#load-more-button').click(function () {
      if (page <= maxPages && !loading) {
        loading = true;
        $('#load-more-button').text('Chargement en cours...');
        $.ajax({
          url: ajaxurl,
          type: 'post',
          data: {
            action: 'load_more_posts',
            page: page,
          },
          success: function (response) {
            page++;
            onSuccessCall(page, maxPages, '.articles-container', response);
          },
        });
      }
    });
  }
  if ($('.ccecqa-ressources')) {
    let maxPages = $('.ccecqa-ressources').attr('data-max');

    $('#load-more-button').click(function () {
      if (page <= maxPages && !loading) {
        loading = true;
        $('#load-more-button').text('Chargement en cours...');
        $.ajax({
          url: ajaxurl,
          type: 'post',
          data: {
            action: 'load_more_ressources',
            page: page,
          },
          success: function (response) {
            page++;
            onSuccessCall(
              page,
              maxPages,
              '.ccecqa-formations__container',
              response,
              false
            );
            hideCardsAfterCall();
          },
        });
      }
    });
  }
  if ($('.ccecqa-agenda')) {
    let maxPages = $('.ccecqa-agenda').attr('data-max');

    $('#load-more-button').click(function () {
      if (page <= maxPages && !loading) {
        loading = true;
        $('#load-more-button').text('Chargement en cours...');
        $.ajax({
          url: ajaxurl,
          type: 'post',
          data: {
            action: 'load_more_agenda',
            page: page,
          },
          success: function (response) {
            page++;
            onSuccessCall(
              page,
              maxPages,
              '.ccecqa-formations__container',
              response
            );
            hideCardsAfterCall();
          },
        });
      }
    });
  }
});
